import rockroom from './rockroom';
import lobby from './lobby';
import office from './office';

export default {
  ...rockroom,
  ...office,
  ...lobby,
};
